<template>
    <Breadcrumbs main="Ui Kits" title="Helper Classes" />
    <div class="container-fluid">
        <div class="row">
            <helperBorders />
            <helperDisplays />
            <backgroundColors />
            <borderColor />
            <ImagesSizes />
            <fontStyle />
            <textColors />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const helperBorders = defineAsyncComponent(() => import("@/components/theme/uikits/helper/helperBorders.vue"))
const helperDisplays = defineAsyncComponent(() => import("@/components/theme/uikits/helper/helperDisplays.vue"))
const backgroundColors = defineAsyncComponent(() => import("@/components/theme/uikits/helper/backgroundColors.vue"))
const borderColor = defineAsyncComponent(() => import("@/components/theme/uikits/helper/borderColor.vue"))
const ImagesSizes = defineAsyncComponent(() => import("@/components/theme/uikits/helper/ImagesSizes.vue"))
const fontStyle = defineAsyncComponent(() => import("@/components/theme/uikits/helper/fontStyle.vue"))
const textColors = defineAsyncComponent(() => import("@/components/theme/uikits/helper/textColors.vue"))
</script>